export default "__VITE_ASSET__ec6f3e9a__"